// @flow
import type { Dispatch } from 'redux';

type updateBadgePayload = {
  conversationsUnseenCount: number,
  newsHubCount: number,
};

export type NotificationsDropdownOpen = { type: 'OPEN_NOTIFICATIONS_DROPDOWN' };
export type NotificationsDropdownClose = {
  type: 'CLOSE_NOTIFICATIONS_DROPDOWN',
};
export type ConversationsDropdownOpen = { type: 'OPEN_CONVERSATIONS_DROPDOWN' };
export type ConversationsDropdownClose = {
  type: 'CLOSE_CONVERSATIONS_DROPDOWN',
};
export type UpdateBadgeCounts = {
  type: 'UPDATE_BADGE_COUNT',
  payload: updateBadgePayload,
};

export const OpenNotificationsDropdown = {
  type: 'OPEN_NOTIFICATIONS_DROPDOWN',
};
export const CloseNotificationsDropdown = {
  type: 'CLOSE_NOTIFICATIONS_DROPDOWN',
};
export const OpenConversationsDropdown = {
  type: 'OPEN_CONVERSATIONS_DROPDOWN',
};
export const CloseConversationsDropdown = {
  type: 'CLOSE_CONVERSATIONS_DROPDOWN',
};

export const dispatchUpdateBadgeCount = (dispatch: Dispatch<any>) => ({
  updateBadgeCount: (badgeCounts: updateBadgePayload) => {
    dispatch({
      type: 'UPDATE_BADGE_COUNT',
      payload: badgeCounts,
    });
  },
});

export const dispatchNotificationsDropdown = (dispatch: Dispatch<any>) => ({
  openNotificationsDropdown: () => dispatch(OpenNotificationsDropdown),
  closeNotificationsDropdown: () => dispatch(CloseNotificationsDropdown),
});

export const dispatchConversationsDropdown = (dispatch: Dispatch<any>) => ({
  openConversationsDropdown: () => dispatch(OpenConversationsDropdown),
  closeConversationsDropdown: () => dispatch(CloseConversationsDropdown),
});

export default null;
